import React from "react";
import { RouteObject } from "../../interfaces/navigation";

const EntryPoint = React.lazy(() => import("../../containers/Brands"));

export const brandsRoutes: RouteObject[] = [
    {
        title: "brands",
        path: "/brands",
        component: <EntryPoint />,
        protected: true
    }
];
